import styled from 'styled-components'


export const LinkStyle = styled.button`
color:#2455EF;
font-size:13px;
border: 0;
background: transparent;
font-weight: 500;
border-bottom: 2px solid;
min-height: 15px;
padding:0; 
margin:0;
`